import nextId from 'react-id-generator';
import { transformFields } from '../../core/utils/methods';
import { distructAndDispatch } from '../../core/utils/methods/destruct-and-dispatch';
import { PROJECT_FUZE_ID_TRANSFORM_FIELDS } from '../../models/constants/transform-fields';
import {
  FinancialData,
  FinancialOOMInformation,
  ProjectFuzeID,
  ProjectManagementDetails,
  ProjectPaceTask,
  User,
} from '../../models/interfaces';
import { FinancialActions } from '../actions/financial.actions';
import { ProjectActions } from '../actions/project.actions';
import { ProjectFuzeIDsActions } from '../actions/project-fuze-ids.actions';

export namespace ProjectManagementEffects {
  export const setFinancial = distructAndDispatch<
    ProjectManagementDetails,
    FinancialData
  >('financial', FinancialActions.getFinancialDataAction);

  export const setOOMInformation = distructAndDispatch<
    ProjectManagementDetails,
    FinancialOOMInformation[]
  >('OOMInformation', FinancialActions.getOOMInformationDataAction);

  export const setCurrentProvidenceAgent = distructAndDispatch<
    ProjectManagementDetails,
    User
  >('providenceAgent', ProjectActions.setCurrentProvidenceAgent);

  export const setPaceTasks = distructAndDispatch<
    ProjectManagementDetails,
    ProjectPaceTask[]
  >('paceTasks', ProjectActions.updateProjectPaceTasksAction);

  export const setPaceTaskFields = distructAndDispatch<
    ProjectManagementDetails,
    ProjectPaceTask[]
  >('paceTaskFields', ProjectActions.updateProjectPaceTaskFields);

  export const setProjectFuzeIDs = distructAndDispatch<
    ProjectManagementDetails,
    ProjectFuzeID[]
  >(
    'fuzeIDs',
    ProjectFuzeIDsActions.setProjectFuzeIDsAction,
    (fuzeIDs: ProjectFuzeID[]) =>
      fuzeIDs?.map((fuzeID: ProjectFuzeID) =>
        transformFields<ProjectFuzeID>(
          { ...fuzeID, generatedId: nextId('PCCategory') },
          PROJECT_FUZE_ID_TRANSFORM_FIELDS,
        ),
      ),
  );
}
